import Icon, { ICONS } from '../../Ui/Icon'

export default function Modal({
  title,
  onClose,
  onConfirm,
  confirmText = 'Save',
  cancelText  = 'Cancel',
  loading     = false,
  danger      = false,
  width       = 400,
  children,
}) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'var(--overlay)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000, backdropFilter: 'blur(4px)',
        padding: '80px 16px 24px',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--bg-card)', border: '1px solid var(--border-active)',
          borderRadius: 12, padding: 28, width, maxWidth: '92vw',
          maxHeight: 'calc(100vh - 120px)',
          overflowY: 'auto',
          boxShadow: '0 8px 40px rgba(0,0,0,0.5)',
          animation: 'fadeSlide 0.25s ease forwards',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <div style={{
            fontFamily: "'Bebas Neue',sans-serif", fontSize: 22,
            color: danger ? '#F87171' : 'var(--gold)', letterSpacing: '0.1em',
          }}>
            {title}
          </div>
          <button onClick={onClose} className="icon-btn" style={{ width: 28, height: 28, borderRadius: 6 }}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={{ marginBottom: onConfirm ? 22 : 0 }}>
          {children}
        </div>

        {/* Footer — only shown if onConfirm is provided */}
        {onConfirm && (
          <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
            <button
              onClick={onClose}
              style={{
                flex: 1, padding: '10px 0', borderRadius: 8,
                border: '1px solid var(--border-main)', background: 'transparent',
                color: 'var(--text-muted)', cursor: 'pointer', fontSize: 13,
                fontFamily: "'Barlow',sans-serif",
              }}
            >{cancelText}</button>

            <button
              onClick={onConfirm}
              disabled={loading}
              style={{
                flex: 1, padding: '10px 0', borderRadius: 8, border: 'none',
                background: danger
                  ? 'rgba(248,113,113,0.15)'
                  : 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
                color: danger ? '#F87171' : '#0A0C0F',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: 13, fontWeight: 700,
                fontFamily: danger ? "'Barlow',sans-serif" : "'Bebas Neue',sans-serif",
                letterSpacing: danger ? 'normal' : '0.08em',
                opacity: loading ? 0.6 : 1,
                border: danger ? '1px solid rgba(248,113,113,0.3)' : 'none',
                transition: 'opacity 0.2s',
              }}
            >{loading ? 'Please wait...' : confirmText}</button>
          </div>
        )}
      </div>
    </div>
  )
}
